import { Injectable } from '@angular/core';
import { ManagementZones } from '@cropx-web/services/api-gateway/MachineDataApiService';
import {
  Action,
  Selector,
  State,
  StateContext,
  createPropertySelectors,
} from '@ngxs/store';
import { produce } from 'immer';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ManagementZonesEditor {
  const type = 'ManagementZonesEditor';

  export class SetManagementZones {
    static readonly type = `[${type}] SetManagementZones`;
    constructor(public managementZones: ManagementZones) {}
  }

  export class UpdateFeatures {
    static readonly type = `[${type}] UpdateFeatures`;
    constructor(public features: ManagementZones['zone_features']) {}
  }
  export class SetLegend {
    static readonly type = `[${type}] SetLegend`;
    constructor(public legend: ManagementZones['legend']) {}
  }

  export class ClearEditor {
    static readonly type = `[${type}] ClearEditor`;
  }

  export class SetZoneOpacity {
    static readonly type = `[${type}] SetZoneOpacity`;
    constructor(public opacity: number) {}
  }
}

export interface ManagementZonesEditorModel {
  managementZones: ManagementZones;
  originalManagementZones: ManagementZones;
  zonesOpacity: number;
}

@State<ManagementZonesEditorModel>({
  name: 'managementZonesEditor',
  defaults: {
    managementZones: null,
    originalManagementZones: null,
    zonesOpacity: 1,
  },
})
@Injectable()
export class ManagementZonesEditorState {
  constructor() {}

  @Action(ManagementZonesEditor.SetManagementZones)
  SetEditorManagementZones(
    ctx: StateContext<ManagementZonesEditorModel>,
    action: ManagementZonesEditor.SetManagementZones,
  ): void {
    ctx.patchState({
      managementZones: action.managementZones,
      originalManagementZones: action.managementZones,
    });
  }

  @Action(ManagementZonesEditor.SetLegend)
  addLegend(
    ctx: StateContext<ManagementZonesEditorModel>,
    action: ManagementZonesEditor.SetLegend,
  ): void {
    ctx.setState(
      produce((state) => {
        state.managementZones.legend = action.legend;
      }),
    );
  }

  @Action(ManagementZonesEditor.UpdateFeatures)
  UpdateFeatures(
    ctx: StateContext<ManagementZonesEditorModel>,
    action: ManagementZonesEditor.UpdateFeatures,
  ): void {
    ctx.setState(
      produce((state) => {
        if (!state.managementZones) {
          return;
        }

        state.managementZones.zone_features = action.features;
      }),
    );
  }

  @Action(ManagementZonesEditor.ClearEditor)
  ClearEditor(ctx: StateContext<ManagementZonesEditorModel>): void {
    ctx.patchState({
      managementZones: null,
    });
  }
  @Action(ManagementZonesEditor.SetZoneOpacity)
  setZoneOpacity(
    ctx: StateContext<ManagementZonesEditorModel>,
    action: ManagementZonesEditor.SetZoneOpacity,
  ): void {
    ctx.patchState({
      zonesOpacity: action.opacity,
    });
  }
}

export class ManagementZonesEditorSelectors {
  static slices = createPropertySelectors<ManagementZonesEditorModel>(
    ManagementZonesEditorState,
  );

  @Selector([ManagementZonesEditorSelectors.slices.managementZones])
  static legend(managementZones: ManagementZones) {
    return managementZones.legend;
  }
  @Selector([ManagementZonesEditorSelectors.slices.originalManagementZones])
  static originalLegend(managementZones: ManagementZones) {
    return managementZones.legend;
  }
}
